import styled from 'styled-components';

import { C } from '../slotBookingEditor/SlotBookingEditor.styles';

export const QuizEditorFields = styled.div`
  &&& .qe-textarea {
    width: 100% !important;
    min-height: 64px;
    padding: 8px 10px !important;
    border: 1px solid ${C.border} !important;
    border-radius: 8px !important;
    background: ${C.card} !important;
    box-shadow: none !important;
    color: ${C.text} !important;
    font-family: inherit;
    font-size: 13px !important;
    line-height: 1.45;
    resize: vertical;
  }

  &&& .qe-textarea:focus {
    border-color: ${C.accent} !important;
    box-shadow: 0 0 0 3px ${C.accent}26 !important;
    outline: none;
  }

  &&& .qe-short-input {
    width: 72px !important;
    text-align: center;
  }

  .qe-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .qe-item-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    color: ${C.tertiary};
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .qe-rotate-up {
    transform: rotate(-90deg);
  }

  .qe-item-actions {
    display: flex;
    gap: 2px;
  }

  .qe-inline {
    display: flex;
    gap: 8px;
  }

  .qe-range {
    width: 140px;
    accent-color: ${C.accent};
  }
`;
